import { useEffect, useState } from 'react';
import { Breakpoint, mediaQueries } from './breakpoints';

export const useBreakpoints = () => {
  const [breakpoints, setBreakpoints] = useState<Record<Breakpoint, boolean> | undefined>();

  useEffect(() => {
    const mediaQueryLists = {};
    const queriesKeys = Object.keys(mediaQueries);

    // To check whether event listener is registered or not
    let isListenerRegistered = false;

    const handleQueryListener = () => {
      const updatedMatches = queriesKeys.reduce((acc, media) => {
        acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
        return acc;
      }, {} as Record<Breakpoint, boolean>);
      //Setting state to the updated matches
      // when document either starts or stops matching a query
      setBreakpoints(updatedMatches);
    };

    const matches = queriesKeys.reduce((acc, queryKey) => {
      if (typeof mediaQueries[queryKey] === 'string') {
        mediaQueryLists[queryKey] = window.matchMedia(mediaQueries[queryKey]);
        acc[queryKey] = mediaQueryLists[queryKey].matches;
      } else {
        acc[queryKey] = false;
      }
      return acc;
    }, {} as Record<Breakpoint, boolean>);

    //Setting state to initial matching mediaQueries
    setBreakpoints(matches);
    isListenerRegistered = true;
    queriesKeys.forEach((media) => {
      if (typeof mediaQueries[media] === 'string') {
        mediaQueryLists[media].addListener(handleQueryListener);
      }
    });
    // }

    return () => {
      //If event listener is attached then remove it when deps change
      if (isListenerRegistered) {
        queriesKeys.forEach((media) => {
          if (typeof mediaQueries[media] === 'string') {
            mediaQueryLists[media].removeListener(handleQueryListener);
          }
        });
      }
    };
  }, [mediaQueries]);

  const {
    sm = false,
    md = false,
    lg = false,
    xl = false,
    xxl = false,
    miniTablet = false,
    tablet = false,
    desktop = false,
    largeDesktop = false,
    mobileOnly = false,
    miniTabletOnly = false,
    tabletOnly = false,
    desktopOnly = false,
  } = breakpoints || {};

  return { sm, md, lg, xl, xxl, mobileOnly, miniTablet, miniTabletOnly, tablet, tabletOnly, desktop, desktopOnly, largeDesktop };
};
